import { Corpus_$ctor_64685318 } from "../../../../fs/Model/Model.js";
import { partsOfSpeech } from "./Cwb.js";
import { singleton } from "../../../../fable_modules/fable-library.3.7.9/List.js";

export function getCorpus(config) {
    return Corpus_$ctor_64685318(config, singleton(partsOfSpeech));
}

